    export const model: any[] = [
        {
            label: "Overview",
            items: [
                {
                    label: "Dashboard",
                    icon: "pi pi-objects-column",
                    to: "/",
                },
            ],
        },
        {
            label: "Chemist Group",
            items: [
                {
                    label: "Companies",
                    icon: "pi pi-warehouse",
                    to: "/companies",
                },
                {
                    label: "Products",
                    icon: "fa-solid fa-capsules",
                    items: [
                        {
                            label: "Laboratories",
                            icon: "pi pi-users",
                            to: "/products-human",
                        },
                        {
                            label: "Animal Health",
                            icon: "fa-solid fa-cow",
                            to: "/products-animal",
                        },
                        {
                            label: "Herbal & Nutraceutical",
                            icon: "fa-solid fa-mortar-pestle",
                            to: "/products-herbal",
                        },
                        {
                            label: "Crop Care",
                            icon: "fa-solid fa-wheat-awn",
                            to: "/products-crop-care",
                        },
                        {
                            label: "Agrobiotech",
                            icon: "fa-solid fa-truck-monster",
                            to: "/products-agrobiotech",
                        },
                        {
                            label: "Gardenia Nursery",
                            icon: "fa-solid fa-seedling",
                            to: "/products-garden",
                        },
                        {
                            label: "Pet Care",
                            icon: "fa-solid fa-paw",
                            to: "/products-paw-mania",
                        },
                    ],
                },
                {
                    label: "Categories",
                    icon: "pi pi-fw pi-bars",
                    to: "/categories",
                },
            ],
        },
        {
            label: "Content Management",
            icon: "pi pi-home",
            items: [
                {
                    label:"Innovation Hub",
                    icon: "pi pi-fw pi-file",
                    to: "/innovation-hub",
                },
                {
                    label: "Newsroom",
                    icon: "pi pi-fw pi-calendar",
                    to: "/newsroom",
                },
                {
                    label: "Careers",
                    icon: "pi pi-fw pi-briefcase",
                    to: "/career",
                },
                {
                    label: "CV Bank",
                    icon: "pi pi-id-card",
                    to: "/cv-bank",
                },
            ],
        },
        {
            label: "Notice Management",
            icon: "pi pi-home",
            items: [
                {
                    label:"Notice Board",
                    icon: "fa-solid fa-sign-hanging",
                    to: "/notice-board",
                },
            ],
        },
    ];